import BossModel from "@/models/BossModel";
import User from "@/models/User/User";

export default class History extends BossModel {

    static apiUrl = 'dossier/ticket/history';

    static entity = 'dossierTicketHistories';

    static fields() {
        return {
            id: this.number(null).nullable(),
            ticket_number: this.attr(null),
            reservation_code: this.attr(null),
            seat_number: this.attr(null),
            emd: this.attr(null),
            printed_at: this.attr(null),
            unprinted_at: this.attr(null),
            printed_by_user_id: this.number(null).nullable(),
            unprinted_by_user_id: this.number(null).nullable(),
            dossier_ticket_id: this.number(null).nullable(),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            printed_by_user: this.belongsTo(User, 'printed_by_user_id'),
            unprinted_by_user: this.belongsTo(User, 'unprinted_by_user_id'),
        }
    }
}
